import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandingPreview from './BrandingPreview';

interface TemplatePreviewModalContentProps {
  branding: any;
  onClose: () => void;
}

const TemplatePreviewModalContent: React.FC<TemplatePreviewModalContentProps> = ({
  branding,
  onClose,
}) => {
  const { t } = useTranslation();

  /*
    Near full viewport: the modal is opened at `width: '96vw'`, and this body
    fills it and most of the height, so the page renders at (up to) its real
    size instead of a thumbnail in a 5xl box. The page itself scales to the
    width it is given (BrandingPreview caps at 1:1).
  */
  return (
    <div className="w-full px-4" aria-label={t('Full preview')}>
      <div className="h-[82vh] overflow-y-auto custom-scrollbar-main rounded-lg border border-hairline-soft bg-surface-sunken/70 p-6">
        <div className="mx-auto max-w-5xl">
          <BrandingPreview branding={branding} />
        </div>
      </div>
    </div>
  );
};

export default TemplatePreviewModalContent;
